import {CashIcon, CheckCircleIcon, CheckIcon, CopyIcon, SendIcon, XCircleIcon} from "../../../shared/components/icons";

// What the order actions look like. Which ones are available is decided by the
// API (`available_actions`). The others (edit, refresh_prices, link, pix) have
// their own place on the page.
export const ACTIONS = {
    send: {
        icon: SendIcon,
        label: "Marcar como enviada",
        title: "Tem certeza?",
        message: "O cliente poderá confirmar ou cancelar a ordem pelo link.",
        color: "primary",
        outline: true,
    },
    confirm: {
        icon: CheckIcon,
        label: "Marcar como confirmada",
        title: "Tem certeza?",
        message: "A ordem passa a valer e poderá ser concluída depois.",
        color: "primary",
    },
    complete: {
        icon: CheckCircleIcon,
        label: "Marcar como concluída",
        title: "Tem certeza?",
        message: "O serviço será dado como feito e a ordem ficará pronta para o pagamento.",
        color: "primary",
    },
    pay: {
        icon: CashIcon,
        label: "Marcar como paga",
        title: "Tem certeza?",
        message: "Depois disso a ordem não poderá mais ser alterada.",
        color: "success",
    },
    cancel: {
        icon: XCircleIcon,
        label: "Cancelar ordem",
        title: "Tem certeza?",
        message: "Esta ação não pode ser desfeita.",
        color: "danger",
        outline: true,
    },
    // Not an API action of its own: cancels, then opens the new-order form
    // pre-filled with this order (see useOrderAction).
    cancelAndClone: {
        icon: CopyIcon,
        label: "Cancelar e clonar",
        title: "Tem certeza?",
        message:
            "A ordem atual será cancelada, mesmo que você não conclua a nova. Um novo formulário será aberto com os mesmos dados.",
        color: "danger",
    },
};

// The steps that move an order along, in the order the API lists them: the
// first is the main one, the rest are alternatives.
export const FLOW = /** @type {("send"|"confirm"|"complete"|"pay")[]} */ (["send", "confirm", "complete", "pay"]);

/** @typedef {keyof typeof ACTIONS} ActionName */
